export default {
  confirm: 'Confirm',
  title: 'Eligible Offers',
};
